<style lang="scss">
  @use "@sourcewhale/shared/svelte-design-system/assets/css/design-system/utils";
  @use "@sourcewhale/shared/svelte-design-system/assets/css/design-system/mixins";
  @use "@sourcewhale/shared/svelte-design-system/assets/css/design-system/colors";

  .header {
    display: flex;
    flex-direction: row;
    align-items: flex-start;
    justify-content: space-between;

    .left {
      display: flex;
      align-items: center;
      justify-content: flex-start;
      padding-top: utils.in_rem(10px);
      gap: utils.in_rem(22px);

      .title-and-links {
        display: flex;
        height: utils.in_rem(66px);
        flex-direction: column;
        align-items: flex-start;
        justify-content: center;
        gap: utils.in_rem(10px);
        // Figma says gap: 16px, but this is from the bottom of the text

        .title {
          @include mixins.h2();
        }

        .links {
          display: flex;
          flex-direction: row;
          gap: utils.in_rem(12px);
        }
      }

      .title,
      .links {
        &.skeleton {
          @include mixins.skeleton(
            (
              background-color: colors.get(interfaceTransparentBlack_4),
              border-radius: 8px,
            )
          );
        }
      }
    }

    .right {
      padding-top: utils.in_rem(10px);
    }
  }
</style>

<script>
  // Stores
  import { companyInsightsStore } from "./stores";
  // Components
  import FeedbackButton from "./Feedback/FeedbackButton.svelte";
  import Logo from "./Logo.svelte";
  import SocialLinks from "./SocialLinks.svelte";

  const { meta } = companyInsightsStore;

  $: skeleton = $meta.fetching || !$meta.firstFetchDone;
</script>

<div class="header">
  <div class="left">
    {#key $companyInsightsStore?.logo}
      <Logo logo={$companyInsightsStore?.logo} {skeleton} size="large" />
    {/key}
    <div class="title-and-links">
      <div class="title" class:skeleton>
        {#if skeleton}
          <span>Loading...............</span>
        {:else}
          {$companyInsightsStore?.name || ""}
        {/if}
      </div>

      <div class="links" class:skeleton>
        {#if skeleton}
          <span>Loading...............</span>
        {:else}
          <SocialLinks />
        {/if}
      </div>
    </div>
  </div>
  <div class="right">
    <FeedbackButton />
  </div>
</div>
